"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileInputField = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _jsxRuntime = require("react/jsx-runtime");
const FileInputField = props => {
  const {
    name,
    label,
    isRequired,
    onChange,
    accept,
    inputRef,
    isMultiple
  } = props;
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  let inputLabel = null;
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
  if (label) {
    inputLabel = /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.InputLabel, {
      ...getTestIdProps(`${name}-file-input-label`),
      htmlFor: name,
      children: label
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.FormControl, {
    fullWidth: true,
    required: isRequired,
    style: {
      display: 'none'
    },
    children: [inputLabel, /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ref: inputRef,
      name: name,
      id: name,
      type: "file",
      accept: accept,
      multiple: isMultiple,
      onChange: onChange
    })]
  });
};
exports.FileInputField = FileInputField;